declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'consent',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
    dataLayer: unknown[];
  }
}

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  if (!measurementId || measurementId === 'G-XXXXXXXXXX') {
    console.warn(
      'Google Analytics measurement ID not configured. Set VITE_GA_MEASUREMENT_ID in your environment.'
    );
    return;
  }

  // Check if gtag is already loaded
  if (typeof window.gtag === 'function') {
    // Just configure with the measurement ID
    window.gtag('config', measurementId, {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: true,
    });
    return;
  }

  // Load GA script dynamically if not already loaded
  const existingScript = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`
  );
  if (!existingScript) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);
  }

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function (...args: unknown[]) {
    window.dataLayer.push(args);
  };

  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    page_title: document.title,
    page_location: window.location.href,
    send_page_view: true,
  });
};

// Track page views
export const trackPageView = (page_path: string, page_title?: string) => {
  if (typeof window.gtag !== 'function') return;

  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!measurementId || measurementId === 'G-XXXXXXXXXX') return;

  window.gtag('config', measurementId, {
    page_path,
    page_title: page_title || document.title,
    page_location: window.location.href,
  });
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Domain specific tracking events
export const trackDomainSearch = (domain: string, available: boolean) => {
  trackEvent('domain_search', 'search', domain, available ? 1 : 0);
};

export const trackDomainRegistrationClick = (domain: string, registrar: string) => {
  trackEvent('registration_click', 'conversion', `${domain} - ${registrar}`);
};

export const trackTLDSelection = (tld: string) => {
  trackEvent('tld_selection', 'interaction', tld);
};

export const trackAlternativesViewed = (originalDomain: string, alternativesCount: number) => {
  trackEvent('alternatives_viewed', 'engagement', originalDomain, alternativesCount);
};
